<main class="donations-page">

  <!-- =====================================================
       HERO
       ===================================================== -->

  <section class="donations-hero">
    <div class="donations-hero-inner">

      <div class="hero-eyebrow">
        <img
          [src]="branding.logoUrl()"
          alt=""
          class="hero-logo"
        />

        <span class="eyebrow-line"></span>
        <span>Community Support</span>
      </div>

      <h1>Donation Requests</h1>

      <p class="hero-description">
        Supporting the organizations, events, and people making
        a difference in the communities we call home.
      </p>

    </div>
  </section>


  <!-- =====================================================
       CONTENT
       ===================================================== -->

  <section class="donations-content">

    <form
      class="donation-form"
      #donationForm="ngForm"
      (ngSubmit)="submitDonationRequest()"
    >

      <!-- Form Header -->

      <header class="form-header">
        <div>
          <span class="form-eyebrow">
            Request Support
          </span>

          <h2>
            Request a Donation
          </h2>

          <p>
            Tell us about your organization, event, and requested
            donation. Please provide as much information as possible.
          </p>
        </div>

        <p class="required-note">
          <span class="required">*</span>
          Required fields
        </p>
      </header>


      <!-- =================================================
           FORM FIELDS
           ================================================= -->

      <div class="form-body">

        <div class="form-grid">

          <!-- Organization -->

          <div class="form-field span-12">
            <label for="organizationName">
              Organization Name
              <span class="required">*</span>
            </label>

            <input
              id="organizationName"
              name="organizationName"
              type="text"
              [(ngModel)]="donationRequest.organizationName"
              required
              autocomplete="organization"
              placeholder="Organization name"
            />
          </div>


          <!-- Contact -->

          <div class="form-field span-6">
            <label for="contactName">
              Contact Name
              <span class="required">*</span>
            </label>

            <input
              id="contactName"
              name="contactName"
              type="text"
              [(ngModel)]="donationRequest.contactName"
              required
              autocomplete="name"
              placeholder="First and last name"
            />
          </div>

          <div class="form-field span-6">
            <label for="contactTitle">
              Contact Title
            </label>

            <input
              id="contactTitle"
              name="contactTitle"
              type="text"
              [(ngModel)]="donationRequest.contactTitle"
              placeholder="Position or role"
            />
          </div>

          <div class="form-field span-6">
            <label for="email">
              Email
              <span class="required">*</span>
            </label>

            <input
              id="email"
              name="email"
              type="email"
              [(ngModel)]="donationRequest.email"
              required
              email
              autocomplete="email"
              placeholder="name@example.com"
            />
          </div>

          <div class="form-field span-6">
            <label for="phone">
              Phone
            </label>

            <input
              id="phone"
              name="phone"
              type="tel"
              [(ngModel)]="donationRequest.phone"
              autocomplete="tel"
              placeholder="(555) 555-5555"
            />
          </div>


          <!-- Address -->

          <div class="form-field span-12">
            <label for="address">
              Street Address
            </label>

            <input
              id="address"
              name="address"
              type="text"
              [(ngModel)]="donationRequest.address"
              autocomplete="street-address"
              placeholder="123 Main Street"
            />
          </div>

          <div class="form-field span-6">
            <label for="city">
              City
            </label>

            <input
              id="city"
              name="city"
              type="text"
              [(ngModel)]="donationRequest.city"
              autocomplete="address-level2"
              placeholder="City"
            />
          </div>

          <div class="form-field span-2 state-field">
            <label for="state">
              State
            </label>

            <input
              id="state"
              name="state"
              type="text"
              [(ngModel)]="donationRequest.state"
              maxlength="2"
              autocomplete="address-level1"
              placeholder="OH"
            />
          </div>

          <div class="form-field span-4">
            <label for="zipCode">
              ZIP Code
            </label>

            <input
              id="zipCode"
              name="zipCode"
              type="text"
              [(ngModel)]="donationRequest.zipCode"
              autocomplete="postal-code"
              placeholder="45365"
            />
          </div>


          <!-- Event -->

          <div class="form-field span-12">
            <label for="eventName">
              Event Name
              <span class="required">*</span>
            </label>

            <input
              id="eventName"
              name="eventName"
              type="text"
              [(ngModel)]="donationRequest.eventName"
              required
              placeholder="Event or initiative name"
            />
          </div>

          <div class="form-field span-6">
            <label for="eventDate">
              Event Date
            </label>

            <input
              id="eventDate"
              name="eventDate"
              type="date"
              [(ngModel)]="donationRequest.eventDate"
            />
          </div>

          <div class="form-field span-6">
            <label for="donationNeededBy">
              Donation Needed By
            </label>

            <input
              id="donationNeededBy"
              name="donationNeededBy"
              type="date"
              [(ngModel)]="donationRequest.donationNeededBy"
            />
          </div>


          <!-- Donation Type -->

          <div class="form-field span-12">
            <label>
              Donation Type
            </label>

            <div class="donation-type-options">

              <label class="donation-type-option">
                <input
                  type="radio"
                  name="donationType"
                  value="Food"
                  [(ngModel)]="donationRequest.donationType"
                />

                <span>
                  Food
                </span>
              </label>

              <label class="donation-type-option">
                <input
                  type="radio"
                  name="donationType"
                  value="Gift Cards"
                  [(ngModel)]="donationRequest.donationType"
                />

                <span>
                  Gift Cards
                </span>
              </label>

              <label class="donation-type-option">
                <input
                  type="radio"
                  name="donationType"
                  value="Monetary Donation"
                  [(ngModel)]="donationRequest.donationType"
                />

                <span>
                  Monetary
                </span>
              </label>

              <label class="donation-type-option">
                <input
                  type="radio"
                  name="donationType"
                  value="Event Sponsorship"
                  [(ngModel)]="donationRequest.donationType"
                />

                <span>
                  Event Sponsorship
                </span>
              </label>

              <label class="donation-type-option">
                <input
                  type="radio"
                  name="donationType"
                  value="Other"
                  [(ngModel)]="donationRequest.donationType"
                />

                <span>
                  Other
                </span>
              </label>

            </div>
          </div>


          <!-- Request -->

          <div class="form-field span-12">
            <label for="requestedAmountOrItems">
              Requested Amount or Items
            </label>

            <input
              id="requestedAmountOrItems"
              name="requestedAmountOrItems"
              type="text"
              [(ngModel)]="donationRequest.requestedAmountOrItems"
              placeholder="e.g. 50 meal vouchers or $250"
            />
          </div>

          <div class="form-field span-12">
            <label for="additionalInformation">
              Additional Information
            </label>

            <textarea
              id="additionalInformation"
              name="additionalInformation"
              rows="5"
              [(ngModel)]="donationRequest.additionalInformation"
              placeholder="Tell us more about your organization, event, audience, or how the donation will be used..."
            ></textarea>
          </div>

        </div>

      </div>


      <!-- =================================================
           FOOTER
           ================================================= -->

      <footer class="form-footer">

        <p>
          Submission does not guarantee approval.
        </p>

        <button
          class="submit-button"
          type="submit"
          [disabled]="
            isSubmitting ||
            donationForm.invalid
          "
        >
          @if (isSubmitting) {
            <span class="spinner"></span>
            Submitting...
          } @else {
            <span>
              Submit Donation Request
            </span>

            <span class="button-arrow">
              →
            </span>
          }
        </button>

      </footer>

    </form>

  </section>

</main>
